/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import ClassNames from 'classnames';
import React, { Fragment, useCallback, useEffect, useRef, useState, } from 'react';
import DurationComponent from '../Player/Duration';
import ControlIconOff from '../Player/icons/control_camera_off.svg';
import ControlIconOn from '../Player/icons/control_camera_on.svg';
import DownloadIcon from '../Player/icons/download.svg';
import FullscreenIcon from '../Player/icons/fullscreen.svg';
import ExitFullscreenIcon from '../Player/icons/fullscreen_exit.svg';
import MoveIconOff from '../Player/icons/move_camera_off.svg';
import MoveIconOn from '../Player/icons/move_camera_on.svg';
import PauseIcon from '../Player/icons/pause.svg';
import PlayArrowIcon from '../Player/icons/play_arrow.svg';
import ReplayIcon from '../Player/icons/replay.svg';
import './index.scss';

import IconPlayButton from '../../assets/icons/play-button.svg';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import SpinnerComponent from '../Player/Spinner';
import usePanAndZoomVideo from '../Player/usePanAndZoomVideo';

// Control icons

const speeds = [
  {
    value: 0.1,
    title: '0.1x',
  },
  {
    value: 0.5,
    title: '0.5x',
  },
  {
    value: 1,
    title: '1x',
  },
  {
    value: 2,
    title: '2x',
  },
  {
    value: 4,
    title: '4x',
  },
  {
    value: 8,
    title: '8x',
  },
  {
    value: 16,
    title: '16x',
  },
];

const PlayerServiceComponent = ({ type, src, poster }) => {
  const progress = useRef();
  const refVideo = useRef();
  const refInterval = useRef();
  const [rotatable, setRotatable] = useState(false);
  const [rotate, setRotate] = useState();
  const [zooming, setZooming] = useState();
  const [pin, setPin] = useState([]);
  const [isPlayVideo, setIsPlayVideo] = useState(false);
  const [video, setVideo] = useState({
    controls: false,
    src: null,
    type: 'video',
    loading: false,
    playbackRate: 1.0,
    url: null,
    playing: false,
    volume: 0.5,
    muted: false,
    played: 0,
    duration: 0,
    ended: false,
    seeking: false,
    fullscreen: false,
  });

  const {
    containerRef,
    onMouseDown,
    onWheel,
    onReset,
    translateX,
    translateY,
    scale,
  } = usePanAndZoomVideo({ zoomable: video.controls });

  const { height: windowHeight, width: windowWidth } = useWindowDimensions();

  useEffect(() => {
    setPin(sessionStorage.getItem('pinCamera')?.split(',') || []);
  }, []);

  useEffect(() => {
    let refClear;
    if (rotate) {
      refClear = setTimeout(() => {
        setRotate(undefined);
      }, 500);
    }
    return () => {
      clearInterval(refClear);
    };
  }, [rotate]);

  useEffect(() => {
    let refClear;
    if (zooming) {
      refClear = setTimeout(() => {
        setZooming(undefined);
      }, 500);
    }
    return () => {
      clearInterval(refClear);
    };
  }, [zooming]);

  useEffect(() => {
    if (type === 'video' && src && isPlayVideo) {
      setVideo((state) => ({
        ...state,
        loading: true,
      }));
      setTimeout(() => {
        let VOLUME = 0.5;
        refVideo.current.setAttribute('src', src);
        refVideo.current.volume = VOLUME;
        refVideo.current.play();
        setVideo((state) => ({
          ...state,
          src,
          type,
          volume: VOLUME,
          loading: false,
          playing: true,
        }));
      }, 400);
    }
  }, [src, type, isPlayVideo]);

  useEffect(() => {
    if (refVideo?.current?.src) {
      handleDropDownTime();
    }
    return () => clearInterval(refInterval.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refVideo?.current?.src]);

  const handleDropDownTime = () => {
    refInterval.current = setInterval(() => {
      const videoTime = refVideo.current.currentTime;
      return setVideo((state) => ({
        ...state,
        played: parseFloat(videoTime / refVideo.current.duration),
      }));
    }, 1000 / video.playbackRate);
  };

  const handlePlay = () => {
    refVideo.current.play();
    return setVideo((state) => ({ ...state, playing: true }));
  };
  const handleRePlay = () => {
    refVideo.current.load();
    refVideo.current.src = video.src;
    refVideo.current.play();
    handleDropDownTime();
    return setVideo((state) => ({
      ...state,
      playing: true,
      ended: false,
    }));
  };

  const handlePause = () => {
    refVideo.current.pause();
    return setVideo((state) => ({ ...state, playing: false }));
  };

  const handleEnded = () => {
    clearInterval(refInterval.current);
    return setVideo((state) => ({ ...state, ended: true, playing: false }));
  };

  const handleDuration = () => {
    let duration = refVideo.current.duration;
    return setVideo((state) => ({
      ...state,
      duration,
    }));
  };

  const handleSeekMouseDown = (event) => {
    return setVideo((state) => ({
      ...state,
      seeking: true,
    }));
  };

  const handleSeekMouseUp = (event) => {
    setVideo((state) => ({
      ...state,
      seeking: false,
    }));
    const jumpTime =
      (event.nativeEvent.offsetX / progress.current.offsetWidth) *
      video.duration;
    // set current time to seek time
    refVideo.current.currentTime = jumpTime;
  };

  const handleSeekChange = (event) => {
    event.persist();
    return setVideo((state) => ({
      ...state,
      played: parseFloat(
        event.nativeEvent.offsetX / progress.current.offsetWidth
      ),
    }));
  };

  const handleSpeedChange = (playbackRate) => {
    refVideo.current.playbackRate = playbackRate;
    return setVideo((state) => ({
      ...state,
      playbackRate,
    }));
  };
  const handleControlsChange = () => {
    onReset();
    return setVideo((state) => ({
      ...state,
      controls: !state.controls,
    }));
  };
  const handleFullscreen = () => {
    // If fullscreen mode is active...
    if (
      !!(
        document.fullScreen ||
        document.webkitIsFullScreen ||
        document.mozFullScreen ||
        document.msFullscreenElement ||
        document.fullscreenElement
      )
    ) {
      // ...exit fullscreen mode
      // (Note: this can only be called on document)
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitCancelFullScreen)
        document.webkitCancelFullScreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
    } else {
      if (containerRef.current.requestFullscreen)
        containerRef.current.requestFullscreen();
      else if (containerRef.current.mozRequestFullScreen)
        containerRef.current.mozRequestFullScreen();
      else if (containerRef.current.webkitRequestFullScreen) {
        refVideo.current.webkitRequestFullScreen();
      } else if (containerRef.current.msRequestFullscreen)
        containerRef.current.msRequestFullscreen();

      setVideo((state) => ({
        ...state,
        fullscreen: true,
      }));
    }
  };
  const exitHandler = useCallback(() => {
    if (
      !document.fullscreenElement &&
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      // Reset zoom
      onReset();

      setVideo((state) => ({
        ...state,
        fullscreen: false,
        controls: false,
      }));
    }
  }, [onReset]);

  useEffect(() => {
    document.addEventListener('fullscreenchange', exitHandler);
    document.addEventListener('webkitfullscreenchange', exitHandler);
    document.addEventListener('mozfullscreenchange', exitHandler);
    document.addEventListener('MSFullscreenChange', exitHandler);

    return () => {
      document.removeEventListener('fullscreenchange', exitHandler);
      document.removeEventListener('webkitfullscreenchange', exitHandler);
      document.removeEventListener('mozfullscreenchange', exitHandler);
      document.removeEventListener('MSFullscreenChange', exitHandler);
    };
  }, [exitHandler]);

  return (
    <>
      <div className="player-service-component">
        <figure
          ref={containerRef}
          onMouseDown={onMouseDown}
          onWheel={onWheel}
          style={{
            paddingBottom: `calc(${windowHeight - 108}/${
              windowWidth - 324
            }*100%)`,
          }}
        >
          <video
            poster={poster}
            ref={refVideo}
            className="player-video"
            onDurationChange={handleDuration}
            onEnded={handleEnded}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              transform: `translate(${translateX}px, ${translateY}px) scale(${scale})`,
            }}
            autoPlay
          />
          {video && video.loading ? (
            <div className="loading">
              <SpinnerComponent />
            </div>
          ) : (
            video.src && (
              <Fragment>
                <div className="bottom-player-component no-select">
                  {video.playing ? (
                    <div>
                      <button onClick={() => handlePause()} className="play">
                        <img src={PauseIcon} alt="" />
                      </button>
                    </div>
                  ) : video.ended ? (
                    <div>
                      <button onClick={() => handleRePlay()} className="play">
                        <img src={ReplayIcon} alt="" />
                      </button>
                    </div>
                  ) : (
                    <div>
                      <button onClick={() => handlePlay()} className="play">
                        <img src={PlayArrowIcon} alt="" />
                      </button>
                    </div>
                  )}
                  {video.type === 'video' && (
                    <Fragment>
                      <div
                        onClick={handleSeekChange}
                        onMouseUp={handleSeekMouseUp}
                        onMouseDown={handleSeekMouseDown}
                        ref={progress}
                        className="progress"
                      >
                        <div
                          className="progress-filled"
                          style={{
                            flexBasis: `${video.played * 100}%`,
                          }}
                        />
                        <div
                          className="point"
                          style={{ marginLeft: `${video.played * 100}%` }}
                        >
                          <div className="timer">
                            <button className="timing">
                              <DurationComponent
                                seconds={
                                  video &&
                                  Math.round(video.played * video.duration)
                                }
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button className="time">
                          <DurationComponent seconds={video.duration} />
                        </button>
                      </div>
                      <div className="speed">
                        <button>
                          {
                            speeds.filter(
                              (speed) => speed.value === video.playbackRate
                            )[0].title
                          }
                        </button>
                        <div className="speeds">
                          {speeds.map((q) => (
                            <Fragment key={q.value}>
                              <button
                                className={ClassNames({
                                  selected: q.value === video.playbackRate,
                                })}
                                key={q.value}
                                onClick={() => handleSpeedChange(q.value)}
                              >
                                {q.title}
                              </button>
                              <br />
                            </Fragment>
                          ))}
                        </div>
                      </div>
                      <div className="download">
                        <button>
                          <a href={src} download target="_blank">
                            <img src={DownloadIcon} alt="" width="35px" />
                          </a>
                        </button>
                      </div>
                    </Fragment>
                  )}
                  {video.fullscreen && (
                    <div className="control">
                      <button
                        onClick={handleControlsChange}
                        className="settings"
                      >
                        <img
                          src={
                            rotatable
                              ? video.controls
                                ? ControlIconOn
                                : ControlIconOff
                              : video.controls
                              ? MoveIconOn
                              : MoveIconOff
                          }
                          alt=""
                        />
                      </button>
                    </div>
                  )}
                  <div className="expand">
                    <button
                      onClick={() => handleFullscreen()}
                      className="fullscreen"
                    >
                      {video.fullscreen ? (
                        <img src={ExitFullscreenIcon} alt="" />
                      ) : (
                        <img src={FullscreenIcon} alt="" />
                      )}
                    </button>
                  </div>
                </div>
              </Fragment>
            )
          )}
        </figure>
      </div>
      {!isPlayVideo && (
        <img
          onClick={() => {
            setIsPlayVideo(true);
          }}
          className="icon-play"
          src={IconPlayButton}
          alt="play-button"
        />
      )}
    </>
  );
};

export default PlayerServiceComponent;
